export default __webpack_public_path__ + "static/media/network_single_ipv6_24.8e536143.svg";